import { mediaObjectName } from "@/lib/media";

/** Ichki ko'ruvchi qanday chizishi kerakligi. */
export type ViewerKind = "image" | "pdf" | "video" | "audio" | "unsupported";

const EXTENSIONS: Record<string, ViewerKind> = {
  png: "image",
  jpg: "image",
  jpeg: "image",
  gif: "image",
  webp: "image",
  avif: "image",
  svg: "image",
  bmp: "image",
  pdf: "pdf",
  mp4: "video",
  webm: "video",
  mov: "video",
  m4v: "video",
  mp3: "audio",
  wav: "audio",
  ogg: "audio",
  m4a: "audio",
};

/**
 * Havoladan fayl turini aniqlaydi.
 *
 * Presigned MinIO havolasida `?X-Amz-Signature=...` bo'ladi va u kengaytmadan
 * KEYIN keladi, shuning uchun so'rov qismi va fragment kesib tashlanadi.
 * Aks holda `diplom.pdf?X-Amz-...` ning kengaytmasi "pdf?x-amz-..." bo'lib
 * chiqar va har bir diplom "qo'llab-quvvatlanmaydi" deb ko'rsatilardi.
 */
export const detectViewerKind = (url?: string | null): ViewerKind => {
  if (!url) return "unsupported";

  // Proksi havolasida (`/api/v1/media/<token>`) kengaytma yo'q — obyekt
  // nomi tokenning o'zidan o'qiladi.
  const withoutQuery = url.split(/[?#]/)[0] ?? "";
  const lastSegment = mediaObjectName(url) ?? withoutQuery.split("/").pop() ?? "";
  const dot = lastSegment.lastIndexOf(".");
  if (dot < 0) return "unsupported";

  const extension = lastSegment.slice(dot + 1).toLowerCase();
  return EXTENSIONS[extension] ?? "unsupported";
};
